import { render, staticRenderFns } from "./AcademicPerformanceRules.vue?vue&type=template&id=37e74912"
import script from "./AcademicPerformanceRules.vue?vue&type=script&lang=js"
export * from "./AcademicPerformanceRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports